import React from "react";
import useHighlightStore, {
  getItemKey,
  HighlightItem,
  ItemType,
} from "../zstore/highlightStore";

type HighlightWrapper = {
  type: (typeof ItemType)[keyof typeof ItemType];
  id?: string;
  children: (isHighlighted: boolean, highlightedItem: any) => React.ReactNode;
};

/**
 * Function as children pattern, children props should be a function accept (boolean, object) to render react nodes.
 */
const HighlightWrapper: React.FC<HighlightWrapper> = ({
  type,
  id,
  ...props
}) => {
  const { items } = useHighlightStore();
  const [isHighlighted, highlightedItem] = checkHighlighted(items, id, type);
  if (typeof props.children !== "function") {
    return null;
  }
  return props.children(isHighlighted, highlightedItem);
};

export function checkHighlighted(
  highlightedItems: Map<string, HighlightItem>,
  targetId: string | undefined,
  type: (typeof ItemType)[keyof typeof ItemType]
): [boolean, HighlightItem | undefined] {
  if (!targetId) {
    return [false, undefined];
  }
  const targetHighlightedItem = highlightedItems.get(
    getItemKey({ id: targetId, type })
  );
  return [targetHighlightedItem !== undefined, targetHighlightedItem];
}

export default HighlightWrapper;
